var exports = {
  "kR": "x28a7bf27--44c54a--cards",
  "Nr": "x28a7bf27--44c54a--card",
  "Ab": "x28a7bf27--44c54a--card-title",
  "yg": "x28a7bf27--44c54a--card-paragraph",
};

module.exports = exports;
